import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_MobileAdviserProfileSummary.scss'
import { Row, Col } from 'react-bootstrap'
import Rating from '../../../common/Rating'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import SecondaryActionButton from '../../../common/Buttons/SecondaryActionButton'
import Spinner from '../../../common/Spinners/Spinner'
import AdviserProfilePictures from '../../../common/AdviserProfiles/AdviserProfilePictures'
import AdviserProfileBlurb from '../../../common/AdviserProfiles/AdviserProfileBlurb'
import DistanceToAdviser from '../../../common/DistanceToAdviser'
import IsIndependent from '../../../common/AdviserProfiles/IsIndependent'
import PropTypes from 'prop-types';

class MobileAdviserProfileSummary extends React.Component {

  static propTypes = {
    adviser: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    contactAdviser: PropTypes.func.isRequired,
    viewProfile: PropTypes.func.isRequired,
    investorLocation: PropTypes.string
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    const profile = this.props.adviser

    return (
      <Row>
        <Col xs={12} className="d-block d-md-none">
          <hr className={styles['red-profile-separator']} />
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfilePictures profilePicture={profile.profilePic} companyLogo={profile.companyLogo} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <AdviserProfileBlurb profile={profile} compact />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col xs={12} className={`${styles['adviser-rating']} d-block d-md-none`}>
              <Rating average={profile?.rating?.average ?? 0} totalReviews={profile?.rating?.totalReviews ?? 0} mobile />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <IsIndependent placement='above' conflictDeclarations={profile.conflictDeclarations} isIndependent={profile.isIndependent} className={styles['is-independnent-margin']} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <DistanceToAdviser
                compact
                fromLocation={this.props.investorLocation}
                toLocation={`${profile.streetAddress}, ${profile.suburb}, ${profile.city}, South Africa`}
                distanceToAdviser={profile.distanceToAdviser} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none">
              <PrimaryActionButton
                className={styles['full-width']}
                buttonText={'Contact adviser'}
                onClick={() => this.props.contactAdviser(profile)} />
              <SecondaryActionButton
                className={`${styles['full-width']} ${styles['view-profile-match']}`}
                buttonText={'View full profile'}
                onClick={() => this.props.viewProfile(profile)} />
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default  (MobileAdviserProfileSummary)
